import {ActionContext} from 'vuex';
import IUserInfo from '@/app/common/model/IUserInfo';
import IUserBalance from '@/app/common/model/IUserBalance';
import NotificationService from '@/app/common/service/NotificationService';
import ApiService from '@/app/common/service/ApiService';
import StorageRepository from '@/app/common/repository/StorageRepository';
import IRootState from '@/app/common/model/IRootState';

interface IAuthModule {
  user: IUserInfo,
  permissions: string[]
}

export default {
  namespaced: true,
  state: {
    permissions: [],
  },

  mutations: {
    setPermissions(data: IAuthModule, permissions: string[]) {
      data.permissions = permissions;
    },
  },
  actions: {
    async getPermissions(context: ActionContext<IAuthModule, IRootState>) {
      try {
        const response = await ApiService.get('/auth/permissions');
        context.commit('setPermissions', response.permissionList);
        StorageRepository.savePermissions(response.permissionList);
      } catch (e) {
        NotificationService.error(e);
      }
    },
  },
  getters: {
    getUserInfo: (data: IAuthModule) => data.user,
    getPermissions: (data: IAuthModule) => data.permissions,
  },
};
